import * as React from "react";
import cn from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconLookup, IconName, library } from '@fortawesome/fontawesome-svg-core'
import { fasr } from '@fortawesome/sharp-regular-svg-icons'
import { fass, faRing } from "@fortawesome/sharp-solid-svg-icons";
import decamelize from 'decamelize';


library.add( fasr, fass )


export type IconProps = {
    size?: "xs" | "s" | "m" | "l" | "xl" | "2xl" | "3xl",
    prefix: "fasr" | "fass",
    iconName: string
} & React.HTMLAttributes<HTMLDivElement>;

const convertFormat = (name: string ) : string => {
    if(name.startsWith('fa') && /[A-Z]/.test(name) && !name.includes('-')){
        const plainName = name.substring(2, name.length)
    return decamelize( plainName, {separator: '-'} );
    }

    return name

};

const FaIcon = React.forwardRef<HTMLDivElement, IconProps>(
    (
        {
            className,
            size,
            prefix,
            iconName,
            children,
            style,
            ...props
        },
        ref
    ) => {
        const name = convertFormat(iconName)
        const icon: IconLookup = { prefix: prefix, iconName: name as IconName }
        return ( <FontAwesomeIcon icon={icon} className={cn(
            `in-icon-fa--${ size }`,
            className
        )
    } /> 

        );
    }
);
FaIcon.displayName = "Icon";

export { FaIcon };